import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { authAPI } from '../../services/api';
import './Profile.css';

const Profile = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [resetStatus, setResetStatus] = useState('');
  const [resetLoading, setResetLoading] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const handleResetPassword = async () => {
    setResetStatus('');
    setResetLoading(true);
    try {
      const response = await authAPI.requestPasswordReset(user.apiName, user.userName);
      if (response.data) {
        setResetStatus('success');
      } else {
        setResetStatus('error');
      }
    } catch {
      setResetStatus('error');
    } finally {
      setResetLoading(false);
    }
  };

  return (
    <div className="profile-page">
      <div className="page-header">
        <h1 className="page-title">My Profile</h1>
      </div>

      <div className="profile-card">
        <h3 className="profile-card-title">Account Information</h3>
        <div className="profile-fields">
          <div className="profile-field">
            <label>Name</label>
            <div className="profile-value">{user?.name || 'N/A'}</div>
          </div>
          <div className="profile-field">
            <label>Username</label>
            <div className="profile-value">{user?.userName || 'N/A'}</div>
          </div>
          <div className="profile-field">
            <label>API</label>
            <div className="profile-value">{user?.apiName || 'N/A'}</div>
          </div>
          <div className="profile-field">
            <label>Role</label>
            <div className="profile-value">{user?.highestRole?.replace('ROLE_', '') || 'N/A'}</div>
          </div>
          <div className="profile-field">
            <label>Company</label>
            <div className="profile-value">{user?.preferences?.companyName || 'N/A'}</div>
          </div>
        </div>
      </div>

      <div className="profile-card">
        <h3 className="profile-card-title">Security</h3>
        <p className="profile-session-text">
          Send a password reset email to the address associated with your account.
        </p>
        {resetStatus === 'success' && (
          <div className="alert alert-success">Password reset email sent successfully.</div>
        )}
        {resetStatus === 'error' && (
          <div className="alert alert-error">
            Unable to request password reset. Please contact your administrator.
          </div>
        )}
        <button className="reset-password-button" onClick={handleResetPassword} disabled={resetLoading}>
          {resetLoading ? 'Sending...' : 'Reset Password'}
        </button>
      </div>

      <div className="profile-card">
        <h3 className="profile-card-title">Session</h3>
        <div className="profile-field">
          <label>Last Login At</label>
          <div className="profile-value">
            {localStorage.getItem('portalLoginAt')
              ? new Date(Number(localStorage.getItem('portalLoginAt'))).toLocaleString()
              : 'N/A'}
          </div>
        </div>
        <p className="profile-session-text">
          End your current session and return to the login screen.
        </p>
        <button className="logout-button" onClick={handleLogout}>
          Logout
        </button>
      </div>
    </div>
  );
};

export default Profile;
